import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'Adding Account',
  description: 'This should only take a few short moments.',
})
